import { simpleSet } from '@r/reducers/utils';

const setGeneralViewMode = simpleSet as redux.reducers.flags.generalViewMode;
export const generalViewMode = setGeneralViewMode(
  'SET_GENERAL_VIEW_MODE',
  '3d'
);
